// extracted by mini-css-extract-plugin
module.exports = {"containerPadding":"styles_containerPadding__y_kr_"};